export default __webpack_public_path__ + "media/verify_user_account_email/title_locale_es-4825ef86.png";